/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncLynxActiveInstrumentLinkToFranklin} from '../api'

export const useMutationSyncLynxActiveInstrumentLinkToFranklin = createReactQueryMutationHook('syncLynxActiveInstrumentLinkToFranklin', syncLynxActiveInstrumentLinkToFranklin)
